import { loadAddthis } from '../components/addthis.js'
import { sticky } from '../components/sticky.js'

import 'menu'
import 'components/flying_cta' 
import 'jump_to_target'
import 'sales_specialist_slides'

document.addEventListener("turbolinks:load", function(event) {
  document.querySelectorAll('.addthis_container').forEach(function (addthisContainer) {
    loadAddthis(addthisContainer)
  })

  document.querySelectorAll('.cta_box_sticky_true').forEach(function(sticky_container){
    const container_position = sticky_container.offsetTop
    window.addEventListener('scroll', function(event){
      sticky(sticky_container, container_position)
    })
  })
})

